import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { BASE_URL } from "../../config/axios";
import { formatDate, formattedDate, formattedDateLong } from "../Date";
import axios from "axios";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { CalenderEdit, CrossRed, Office, SearchSmall, UpdatePencil } from "../AllSvg";
import { OnboardNewEmployeeData } from "./update_details/OnboardEmployeeModel";
import { handleErrorToast } from "../CustomFunctions";
import Loader from "../Loader";

const UpdateJoiningDate = ({ i, getOnboardingList }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    remarks: "",
    joining_date: "",
    coordinateby: `${sessionStorage.getItem("emp_code")} - ${sessionStorage.getItem("name")} `,
  });
  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks", "joining_date"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      // upcoming_onboarding_status: 'approved',
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getOnboardingList("approved");
          setShow(false);
        } else {
          console.error(res)
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Change Joining Date"
        onClick={handleShow}
      >
        <CalenderEdit />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Change Onboarding Date for {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="joining_date" className="form-labels font-weight500    font-size-subheading">
                Joining Date
              </label>
              <input
                type="date"
                id="joining_date"
                name="joining_date"
                placeholder="DD/MM/YYYY"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.joining_date}
                className={`form-input form-input-background ${errors.joining_date
                  ? "error"
                  : inputState.joining_date
                    ? "success"
                    : ""
                  }`}
              />
              {errors.joining_date && (
                <span className="error-message font-size-text ">{errors.joining_date}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Remarks<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button  font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ApproveModel = ({ i, getOnboardingList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    remarks: "",
    upcoming_onboarding_status: "approved",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      upcoming_onboarding_status: "approved",
      coordinateby: `${sessionStorage.getItem("emp_code")} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getOnboardingList("approved");
          setShow(false);
        } else {
          console.error(res)
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        title="Approve"
        className="model-edit-button-ml"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15 4.5L6.75 12.75L3 9"
            stroke="#145650"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Approve {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Reason for Approval<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button  font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Approve
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const RejectModel = ({ i, getOnboardingList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    remarks: "",
    upcoming_onboarding_status: "rejected",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      upcoming_onboarding_status: "rejected",
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getOnboardingList("approved");
          setShow(false);
        } else {
          console.error(res)
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Reject"
        onClick={handleShow}
      >
        <CrossRed />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Reject {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Reason for Rejection<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button    model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button    model-button-submit font-weight500 "
                onClick={handleFormSubmitPut}
              >
                Reject
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const CompleteOnboarding = ({ email, i, getOnboarding }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setEmpData({})
    setShow(false)
  };

  const handleShow = () => {
    if (email) {
      getEmployeeDetails(email)
    }
    setShow(true)
  };

  const [empData, setEmpData] = useState({});

  const [buffer, setBuffer] = useState(false); //loading logic
  const getEmployeeDetails = async (email) => {
    setBuffer(true); //loading logic
    try {
      let res = await axios.get(`${BASE_URL}/wfm/get-ourcompanydetails-byemail/${email}/`);
      if (res.status === 200) {
        setEmpData(res.data)
        // handleClose();
      } else {
        console.error(res)
      }
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffer(false);
    }
  };


  const [formData, setFormData] = useState({
    coordinateby: `${sessionStorage.getItem("emp_code")} - ${sessionStorage.getItem("name")} `,
  });

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      protal_created: true,
      coordinateby: `${sessionStorage.getItem("emp_code")} - ${sessionStorage.getItem("name")} `,
    };

    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.put(
        `${BASE_URL}/jd/jobapplicant/${i.id}/`,
        updatedformvalue
      );
      if (res.status === 200) {
        await getOnboarding();
        handleClose();
      } else {
        console.error(res)
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Employee Added"
        className="model-update-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            {buffer ?
              <Loader container={true} />
              :
              empData &&
              <div className="bdy-div ">
                <h3 className="task-Tab-heading  font-weight500    font-size-heading">
                  Profile Already Created for :-
                </h3>
                {/* <p style={{ textAlign: 'center' }}>:</p> */}
                {/* <div className="form-flex-wrap"> */}

                <p style={{ textAlign: "center" }}>Name : {empData.name}</p>
                <p style={{ textAlign: "center" }}>Email : {empData.user_detail}</p>
                <p style={{ textAlign: "center" }}>Emp Code : {empData.emp_code}</p>
                <p style={{ textAlign: "center" }}>
                  Machine Code : {empData.machine_code}
                </p>
                <p style={{ textAlign: "center" }}>
                  Department : {empData.department_name}
                </p>
                <p style={{ textAlign: "center" }}>
                  Reporting Head Id : {empData.reporting_head}
                </p>
                <p style={{ textAlign: "center" }}>
                  Mobile Number : {empData.mobile_number}
                </p>
                <p style={{ textAlign: "center" }}>
                  Location : {empData.location_name}
                </p>
                <p style={{ textAlign: "center" }}>
                  Joining Date : {formatDate(empData.joining_date)}
                </p>
                <p style={{ textAlign: "center" }}>Type : {empData.employee_type}</p>

                {/* </div> */}

                <div className="button-models">
                  <button
                    className="model-button  font-weight500    model-button-cancel font-size-heading"
                    onClick={handleClose}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button  font-weight500    model-button-leave font-weight500    font-size-heading"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    Done
                  </button>
                </div>
              </div>
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateOnboardingDetails = ({ i, getOnboardingList }) => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    access: i.access,
    joiningkit: i.joiningkit,
    induction: i.induction,
    systemallotment: i.systemallotment,
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCheckboxChange = (name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: !prevData[name],
    }));
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          formData
        );

        if (res.status === 200) {
          await getOnboardingList();
          setShow(false);
        } else {
          console.error(res)
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const validateForm = () => {
    // Your validation logic here
    return true; // Placeholder for now
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Change Onboarding Details"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Onboarding Of {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <div className="flex-column">
                <label htmlFor="access" className="form-labels font-weight500    font-size-subheading">
                  Access
                </label>
                <input
                  id="access"
                  name="access"
                  type="checkbox"
                  onChange={() => handleCheckboxChange("access")}
                  checked={formData.access}
                  className="form-checkbox"
                />
              </div>
              <div className="flex-column">
                <label htmlFor="joiningkit" className="form-labels font-weight500    font-size-subheading">
                  Joining Kit
                </label>
                <input
                  id="joiningkit"
                  name="joiningkit"
                  type="checkbox"
                  onChange={() => handleCheckboxChange("joiningkit")}
                  checked={formData.joiningkit}
                  className="form-checkbox"
                />
              </div>
              {/* Repeat similar code for other checkboxes */}
            </div>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <div className="flex-column">
                <label htmlFor="induction" className="form-labels font-weight500    font-size-subheading">
                  Induction
                </label>
                <input
                  id="induction"
                  name="induction"
                  type="checkbox"
                  onChange={() => handleCheckboxChange("induction")}
                  checked={formData.induction}
                  className="form-checkbox"
                />
              </div>
              <div className="flex-column">
                <label htmlFor="systemallotment" className="form-labels font-weight500    font-size-subheading">
                  System Allotment
                </label>
                <input
                  id="systemallotment"
                  name="systemallotment"
                  type="checkbox"
                  onChange={() => handleCheckboxChange("systemallotment")}
                  checked={formData.systemallotment}
                  className="form-checkbox"
                />
              </div>
            </div>

            <div className="button-models">
              <button className="model-button  model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 1;
const day = today.getDate();
const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
  .toString()
  .padStart(2, "0")}`;


const Upcomingonboarding = () => {
  const [onboardingList, setOnboardingList] = useState([]);
  const [toggleState, setToggleState] = useState("approved");
  const [selectedName, setName] = useState("");
  const [filteredList, setfilteredList] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const getOnboardingList = async (stateArg, companyArg) => {
    const finalState = stateArg || toggleState;
    const finalCompany = companyArg || toggleCompany;
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/jd/upcomingonbordingstatus/${finalState}/${finalCompany}/`
      );
      setOnboardingList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };
  useEffect(() => {
    getOnboardingList(toggleState, toggleCompany);
  }, [toggleState, toggleCompany]);

  const applyFilters = () => {
    let filteredData = onboardingList;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchh = employee.department_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchhh = employee.position_name
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return nameMatch || nameMatchh || nameMatchhh;
      });
    }

    setfilteredList(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedName, onboardingList]);

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="table-css-white-background">
        <div className="table-heading-flex field-cont-between">
          <div className="repo-heading font-weight500    font-size-heading">Upcoming Onboarding</div>
          <div className="field-cont">
            {PERMISSION_AUTHORITY ? <div className="table-searchh dropdown-container field-cont-div">
              <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

              </select>
            </div> : null
            }

            <div className="table-search field-cont-div">
              <div>
                <SearchSmall />
              </div>
              <div>
                <input
                  style={{ width: "250px" }}
                  placeholder="Name/Department/Designation "
                  type="text"
                  value={selectedName}
                  className="navbar-inputt font-weight400  font-size-text"
                  onChange={(e) => setName(e.target.value)}
                // value={searchQuery}
                // onChange={handleSearchChange}
                />
              </div>
            </div></div>
        </div>
        <div className="table-heading-flex">
          <div className="bloc-tabs-with-white-bg bloc-tabs-with-lesswhite-bg">
            <button
              className={
                toggleState === "approved"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("approved")}
            >
              Approved
            </button>
            <button
              className={
                toggleState === "rejected"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("rejected")}
            >
              Rejected
            </button>
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">ID</th>
              <th className="align-left">Name</th>
              <th className="align-center">Department</th>
              <th className="align-center">Designation</th>
              <th className="align-center">Type</th>
              <th className="align-center">Remark/Reason</th>
              <th className="align-center">Joining Date</th>
              <th className="align-center">Status</th>
              <th className="align-center">Action</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {filteredList.map((i, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="10"></td>
                    </tr>
                    <tr
                      style={{
                        backgroundColor:
                          i.joining_date === formattedDatee ? "#c1fbaf" : "white",
                      }}
                      className="custom-table-head-td"
                    >
                      <td className="align-left">{index + 1}</td>
                      <td className="align-leftt">{i.name}</td>
                      <td className="align-center">{i.department_name}</td>
                      <td className="align-center">{i.position_name}</td>
                      <td className="align-center">{i.job_type}</td>
                      <td className="align-center">{i.remarks}</td>
                      <td className="align-center">
                        {formattedDateLong(i.joining_date)}
                      </td>
                      <td className="align-center">{i.status}</td>
                      <td className="align-center">
                        <UpdateJoiningDate
                          i={i}
                          getOnboardingList={getOnboardingList}
                        />
                        {toggleState === "approved/" ? (
                          <RejectModel
                            i={i}
                            getOnboardingList={getOnboardingList}
                          />
                        ) : (
                          <ApproveModel
                            i={i}
                            getOnboardingList={getOnboardingList}
                          />
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>}
        </table>
      </div>
    </>
  );
};

const Onboardingtable = () => {
  // const [toggleState, setToggleState] = useState("approved/");
  const [selectedName, setName] = useState("");
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [filter1, setfilter1] = useState("");
  const [filter2, setfilter2] = useState("");
  const [filter3, setfilter3] = useState("");
  const [filter4, setfilter4] = useState("");
  const [onboardingList, setOnboardingList] = useState([]);
  const [filteredList, setfilteredList] = useState([]);

  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));

  const getOnboardingList = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/jd/onboarding/${toggleCompany}/`);
      setOnboardingList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  const applyFilters = () => {
    let filteredData = onboardingList;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchh = employee.department_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchhh = employee.position_name
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return nameMatch || nameMatchh || nameMatchhh;
      });
    }

    if (filter1) {
      filteredData = filteredData.filter((employee) => employee.access);
    }

    if (filter2) {
      filteredData = filteredData.filter((employee) => employee.joiningkit);
    }

    if (filter3) {
      filteredData = filteredData.filter((employee) => employee.induction);
    }

    if (filter4) {
      filteredData = filteredData.filter(
        (employee) => employee.systemallotment
      );
    }

    setfilteredList(filteredData);
  };
  useEffect(() => {
    getOnboardingList();
  }, [toggleCompany]);

  useEffect(() => {
    applyFilters();
  }, [selectedName, onboardingList, filter1, filter2, filter3, filter4]);

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">

            <div className="field-cont-div">
              <span className="input-color-light">Access</span>
              <input
                type="checkbox"
                checked={filter1}
                onChange={(e) => setfilter1(e.target.checked)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <span className="input-color-light">Joining Kit</span>
              <input

                type="checkbox"
                checked={filter2}
                onChange={(e) => setfilter2(e.target.checked)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <span className="input-color-light">Induction</span>
              <input

                type="checkbox"
                checked={filter3}
                onChange={(e) => setfilter3(e.target.checked)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <span className="input-color-light">System Allotment</span>
              <input

                type="checkbox"
                checked={filter4}
                onChange={(e) => setfilter4(e.target.checked)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex field-cont-between">
          <div className="repo-heading font-weight500    font-size-heading">Onboarding</div>
          <div className="field-cont">
            {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
              <Office />
              <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

              </select>
            </div> : null
            }
            <div className="table-search ">
              <div>
                <SearchSmall />
              </div>
              <div>
                <input
                  placeholder="Name/Department/Designation "
                  type="text"
                  value={selectedName}
                  className="width-15vw navbar-inputt font-weight400  font-size-text"
                  onChange={(e) => setName(e.target.value)}
                // value={searchQuery}
                // onChange={handleSearchChange}
                />
              </div>
            </div>
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">ID</th>
              <th className="align-left">Name</th>
              <th className="align-center">Department</th>
              <th className="align-center">Designation</th>
              {/* <th className="align-center">Experience</th> */}
              <th className="align-center">Access</th>
              <th className="align-center">Joining kit</th>
              <th className="align-center">Induction</th>
              <th className="align-center">System Allotment</th>
              <th className="align-center">Action</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> :
            <tbody>
              {filteredList.map((i, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="10"></td>
                    </tr>
                    <tr
                      style={{
                        backgroundColor:
                          i.joining_date === formattedDatee ? "#c1fbaf" : "white",
                      }}
                      className="custom-table-head-td"
                    >
                      <td className="align-left">{index + 1}</td>
                      <td className="align-leftt">{i.name}</td>
                      <td className="align-center">{i.department_name}</td>
                      <td className="align-center">{i.position_name}</td>
                      {/* <td className="align-center">{i.Experience}</td> */}
                      <td className="align-center">
                        <input
                          type="checkbox"
                          checked={i.access}
                          readOnly
                          className="form-checkbox"
                        />
                      </td>
                      <td className="align-center">
                        <input
                          type="checkbox"
                          checked={i.joiningkit}
                          readOnly
                          className="form-checkbox"
                        />
                      </td>
                      <td className="align-center">
                        <input
                          type="checkbox"
                          checked={i.induction}
                          readOnly
                          className="form-checkbox"
                        />
                      </td>
                      <td className="align-center">
                        <input
                          type="checkbox"
                          checked={i.systemallotment}
                          readOnly
                          className="form-checkbox"
                        />
                      </td>
                      <td className="align-center">
                        <UpdateOnboardingDetails
                          i={i}
                          getOnboardingList={getOnboardingList}
                        />
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>}
        </table>
      </div>
    </>
  );
};

const NewEmployeeJoining = () => {
  const [onboarding, setOnboarding] = useState([]);
  const [selectedName, setName] = useState("");
  const [filteredList, setfilteredList] = useState([]);
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const getOnboarding = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/jd/newjoining/${toggleCompany}/`);
      setOnboarding(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getOnboarding();
  }, [toggleCompany]);

  const applyFilters = () => {
    let filteredData = onboarding;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchh = employee.user_detail
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return nameMatch || nameMatchh;
      });
    }

    setfilteredList(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedName, onboarding]);

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="table-css-white-background">
        <div className="table-heading-flex field-cont-between">
          <div className="repo-heading font-weight500    font-size-heading">New Empolyee joining</div>
          <div className="field-cont">
            {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
              <Office />
              <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

              </select>
            </div> : null
            }
            <div className="table-search ">
              <div>
                <SearchSmall />
              </div>
              <div>
                <input
                  style={{ width: "250px" }}
                  placeholder="Name/Email "
                  type="text"
                  value={selectedName}
                  className="navbar-inputt font-weight400  font-size-text"
                  onChange={(e) => setName(e.target.value)}
                // value={searchQuery}
                // onChange={handleSearchChange}
                />
              </div>
            </div></div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr NO</th>
              <th className="align-left">Name</th>
              <th className="align-center">Email</th>
              <th className="align-center">Joining Date</th>
              <th className="align-right">Action</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {filteredList
                .sort(
                  (a, b) => new Date(a.joining_date) - new Date(b.joining_date)
                )
                .map((i, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor:
                            i.joining_date === formattedDatee
                              ? "#c1fbaf"
                              : "white",
                        }}
                        className="custom-table-head-td"
                      >
                        <td className="align-left">{index + 1}</td>
                        <td className="align-left">{i.name}</td>
                        <td className="align-center">{i.user_detail}</td>
                        <td className="align-center">
                          {formattedDateLong(i.joining_date)}
                        </td>

                        <td className="align-right">
                          {i.company_details_exist ? (
                            <CompleteOnboarding
                              email={i.user_detail}
                              i={i}
                              getOnboarding={getOnboarding}
                            />
                          ) : (
                            <OnboardNewEmployeeData
                              data={i}
                              email={i.user_detail}
                              SUB_COMPANIES={SUB_COMPANIES}
                            />
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>}
        </table>
      </div>
    </>
  );
};

export { Onboardingtable, Upcomingonboarding, NewEmployeeJoining };

